import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import React from 'react';
import { IPlan } from 'types/Plan';

import { Divider, Stack } from '@mui/material';

import { TutorPlanCardBenefits } from '../TutorPlanCardBenefits';
import { TutorPlanCardHeader } from '../TutorPlanCardHeader';
import { useTutorUserPlan } from 'context';

interface Props {
  plan: IPlan;
}

export const TutorPlanCard: React.FC<Props> = ({ plan }) => {
  // FIXME: Card don't work in different context
  const { couponValues } = useTutorUserPlan();

  if (!plan) {
    return null;
  }

  return (
    <PaperCardTemplate childrenProps={{ px: 6 }}>
      <Stack spacing={3} mb={2}>
        <TutorPlanCardHeader
          planName={plan.title}
          planPrice={plan.price}
          discountPlanPrice={couponValues?.newValue}
          installmentText={plan.installmentText}
        />

        <Divider sx={{ pt: 1 }} />

        <TutorPlanCardBenefits
          pt={1}
          description={plan.description}
          benefits={plan.benefits}
        />
      </Stack>
    </PaperCardTemplate>
  );
};
